import { RumInitConfiguration, datadogRum } from "@datadog/browser-rum";
import { APPLICATION_ID, CLIENT_TOKEN, DATADOG_SITE } from "./constants";

export type InitializeRumProps = Partial<RumInitConfiguration> & {
  service: string;
  enableSessionRecording: boolean;
};

export const initializeRum = ({
  service,
  allowedTracingUrls,
  enableSessionRecording,
  ...rest
}: InitializeRumProps) => {
  datadogRum.init({
    applicationId: APPLICATION_ID,
    clientToken: CLIENT_TOKEN,
    site: DATADOG_SITE,
    service,
    traceSampleRate: 100,
    sessionReplaySampleRate: enableSessionRecording ? 100 : 0,
    useCrossSiteSessionCookie: true,
    trackSessionAcrossSubdomains: true,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    allowedTracingUrls,
    beforeSend: (event) => {
      // remove token and code from startSession url
      event.view.url = event.view.url.replace(
        /(token|code)=[^&]*/gm,
        "$1=REDACTED"
      );
      if (event.view.referrer) {
        event.view.referrer = event.view.referrer.replace(
          /(token|code)=[^&]*/gm,
          "$1=REDACTED"
        );
      }

      return true;
    },
    ...rest,
  });
};

export const startRumSessionReplayRecording = () => {
  datadogRum.startSessionReplayRecording();
};
